import React, {
  useState,
  MouseEvent,
  useEffect,
  SyntheticEvent,
  ReactElement,
  ChangeEvent
} from 'react';
import {TreeView} from '@mui/x-tree-view';
import '@mui/lab';
import {TreeItem, TreeItemProps} from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  getCmsData,
  getLMSFileData,
  getSearchForm,
  postUploadData
} from '@shared/services/service-handlers/PrivateService';
import SearchIcon from '@mui/icons-material/Search';
import {v4 as uuidv4} from 'uuid';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Checkbox,
  SvgIcon,
  SvgIconProps,
  Box,
  Grid,
  Input,
  TextField,
  IconButton,
  InputAdornment,
  useTheme,
  FormControlLabel,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';

import {CircularProgress} from '@mui/material';
import AddFolder from './AddFolders';
import {useAppContext} from '@context/AppContext';
import EncryptUtils from 'src/utils/EncryptUtils';
import AddEmbeddedCodeDialog from './AddEmbedCode';
import AddLinkCodeDialog from './AddNewLinks';
import getIconForNodeType from './lmscmsicon';
import FileThumbnail, {
  fileNameByUrl,
  fileThumb,
  fileTypeByUrl
} from 'src/minimal-components/file-thumbnail';
import {RHFSingleUpload} from 'src/minimal-components/hook-form';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import {FormProvider} from 'react-hook-form';
import {LoadingButton} from '@mui/lab';
import CMSUpload from './CMSUploadData';
import {useBoolean} from 'src/hooks/use-boolean';
import {CustomFile} from '@components/upload';
import axios, {CancelTokenSource} from 'axios';
import {
  MainContainer,
  MainDocViewContainer
} from '../../../../../../src/components/documents/DocumentsComponentStyles';
import CustomDocViewer from '@components/docViewer/CustomDocViewer';
import EmptyContent from '@components/empty-content';
// import {height} from '@mui/system';
import {ResizableBox} from 'react-resizable';
import CustomLMSDocViewer from './DocViewer/CustomLMSVeiwer';
import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {TreeItemWrapper} from '@components/treeView/CustomTreeViewStyle';
import {useSelectedDocumentContext} from '@context/SelectedDocumentContext';
import {node} from 'prop-types';
import AuthUtils from 'src/utils/AuthUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import FileManagerNewFolderDialog from 'src/sections/file-manager/file-manager-new-folder-dialog';

// Define a type for tree nodes

interface TreeNode {
  [x: string]: any;
  Id: string;
  Name: string;
  NodeType: 'Folder' | 'file' | 'link' | 'embeddedCode' | 'root';
  ParentId?: string;
  Access: boolean;
  UploadedFile: string;
  Icon: string;
  children?: TreeNode[];
}
const initialTree: TreeNode = {
  Id: 'root',
  Name: 'Root',
  NodeType: 'Folder',
  ParentId: 'null',
  Access: true,
  UploadedFile: '',
  Icon: 'folder',
  children: []
};
interface FileDetails {
  Id: string | undefined;
  ParentId: string | null; // Allow null
  Name: string;
}
interface FileToUpload {
  fileData: string | ArrayBuffer | null; // Assuming base64-encoded string of the file's data
  fileName: string | null; // The name of the file
  fileType: string | null; // The MIME type of the file
  fileError: string;
}

const CmsComponent: React.FC = () => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const theme = useTheme();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const source = React.useRef<CancelTokenSource | null>(null);
  const [isNodeToggled, setIsNodeToggle] = useState(false);
  const [searchData, setSearchData] = React.useState('');
  const [treeData, setTreeData] = useState<TreeNode[]>([]);
  // const [openDialog, setOpenDialog] = useState(false);
  const openDialog = useBoolean();
  const [isLoading, setIsLoading] = useState(false);
  const [isBaseLoading, setIsBaseLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [fileDetails, setFileDetails] = useState<FileDetails>({
    Id: undefined,
    ParentId: '',
    Name: ''
    // initialize other fields...
  });
  const [expandedNodes, setExpandedNodes] = useState<string[]>([]);
  const [expanded, setExpanded] = useState<string[]>([]);
  const [openedNodes, setOpenedNodes] = useState<string[]>([]);
  const [childNodes, setChildNodes] = useState<TreeNode[]>([]);
  const [docData, setDocData] = useState<TreeNode | null>();
  const [uploadedId, setuploadId] = useState<string | undefined>(undefined);
  const [newId, setNewId] = useState<string | undefined>(undefined);
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number | null;
    mouseY: number | null;
    nodeId: {id: string | null; type?: string | null};
  }>({mouseX: null, mouseY: null, nodeId: {id: null}});
  const initialFileDetails = {
    Id: '', // Assuming 'Id' is a string. Adjust as per your data structure.
    ParentId: '', // or null, depending on what your data expects
    Name: '' // Assuming 'Name' is a string. Adjust as per your data structure.
    // ... any other fields that 'fileDetails' might have
  };
  const [docViewerWidth, setDocViewerWidth] = useState<number>(700);
  const [selectedData, setSelectedData] = useState<string | null>(null);
  const [isLoadingTree, setIsLoadingTree] = useState(false);
  const [mimeType, setMimeType] = useState('');
  const [loading, setLoading] = useState(false);
  const [isAddFolderOpen, setIsAddFolderOpen] = useState(false);
  const [isAddEmbeddedOpen, setIsAddEmbeddedOpen] = useState(false);
  const [isAddLinkOpen, setIsAddLinkOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [initialdata, setInitialdata] = useState<TreeNode[]>([]);
  const [renameState, setRenameState] = useState<{
    isRenaming: boolean;
    nodeId: string | null;
    newName: string;
  }>({isRenaming: false, nodeId: null, newName: ''});
  const [filesToUpload, setFilesToUpload] = useState<FileToUpload[]>([]);
  const [deleteMode, setDeleteMode] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [directdeleteDialogOpen, setDirectDeleteDialogOpen] = useState(false);
  const [checkedItems, setCheckedItems] = useState<{[key: string]: boolean}>(
    {}
  );
  const [initialResponse, setInitialResponse] = useState<string>();
  const [isInitialFetchDone, setIsInitialFetchDone] = useState<boolean>(false);
  const Loader = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}>
        <CircularProgress />
      </div>
    );
  };
  const transformDataToTreeNode = (data: TreeNode[]): TreeNode[] => {
    // Create a node map for easy lookup
    const nodeMap = new Map<string, TreeNode>();
    data.forEach(node => {
      if (node.Access === true) {
        // Check if Access is 1
        node.children = []; // Initialize children array
        nodeMap.set(node.Id, node);
      }
    });
    // Identify root nodes and build the tree
    const rootNodes: TreeNode[] = [];
    data.forEach(node => {
      if (node.Access === true) {
        // Check if Access is 1
        if (node.ParentId === null || node.ParentId === undefined) {
          rootNodes.push(node); // Root node
        } else {
          const parentNode = nodeMap.get(node.ParentId);
          if (parentNode) {
            parentNode.children?.push(node); // Add node to its parent's children array
          }
        }
      }
    });
    // Return the tree
    return rootNodes;
  };
  useEffect(() => {
    const initialFetching = async () => {
      try {
        setIsLoading(true);
        const response = await getSearchForm(
          applicationName,
          'content-management'
        );
        setInitialResponse(response);
        setDocData(null);
        setIsLoading(false);
      } catch (error) {
        console.error('Error during initial fetching:', error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
        setIsInitialFetchDone(true); // Indicate that the initial fetch is done
      }
    };

    initialFetching();
  }, []);
  useEffect(() => {
    if (!isInitialFetchDone) return; // Ensure first useEffect has completed

    const dataFetching = async () => {
      try {
        setIsLoadingTree(true);
        const data: any = {
          sql_data: initialResponse,
          operation: 'SEARCH'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);

        const valueCms = await getCmsData(
          'LMS',
          'content-management',
          {
            tk: encryptRequestData
          },
          'SEARCH'
        );
        setInitialdata(valueCms.data); // Assuming setInitialData is defined to set state
        const transformedData = transformDataToTreeNode(valueCms.data);
        setTreeData(transformedData);
        setExpanded([]);
        setIsLoadingTree(false);
      } catch (error) {
        setIsLoadingTree(false);
        console.error('Error during data fetching:', error);
      }
    };

    dataFetching();
  }, [isInitialFetchDone, uploadedId]);

  useEffect(() => {
    if (newId !== undefined) {
      setFileDetails(prevDetails => ({...prevDetails, Id: newId}));
    }
  }, [newId]);
  const updateTreeData = (
    nodes: TreeNode[],
    parentId: string,
    newChildren: TreeNode[],
    ChildrenFetched: boolean
  ): TreeNode[] => {
    return nodes.map(node => {
      if (node.Id === parentId) {
        // Update the parent node with new children and mark as fetched
        return {...node, children: newChildren, ChildrenFetched};
      }
      if (node.children) {
        // Recursively update children
        return {
          ...node,
          children: updateTreeData(
            node.children,
            parentId,
            newChildren,
            ChildrenFetched
          )
        };
      }
      return node;
    });
  };

  const fetchChildNodes = async (parentNode: any) => {
    let folderContents: TreeNode[] = [];
    const {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      children: childNodes,
      HasDocuments: hasDocuments,
      Id: id
    } = parentNode;
    if (childNodes) {
      folderContents = [...childNodes];
    }
    if (hasDocuments) {
      const data: any = {
        sql_data: initialResponse,
        data: {Id: id},
        operation: 'GETDATA'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);

      const response = await getCmsData('LMS', 'content-management', {
        tk: encryptRequestData
      });
      folderContents = [...folderContents, ...response.data];
    }
    return folderContents;
  };
  const findNodesById = (id: string): TreeNode | null => {
    const traverse = (nodes: TreeNode[]): TreeNode | null => {
      for (const node of nodes) {
        if (String(node.Id) === id) {
          return node; // Return the matching node and its subtree
        }
        if (node.children && node.children.length > 0) {
          const result = traverse(node.children);
          if (result) {
            return result; // Return the result from the child traversal
          }
        }
      }
      return null; // Return null if no match is found
    };

    return traverse(treeData);
  };
  const handleFolderChange = async (event: SyntheticEvent, nodes: string[]) => {
    setIsNodeToggle(!isNodeToggled);
    setExpanded(nodes);
    const expandingNodes: string[] = nodes.filter(
      eachNode => !expandedNodes.includes(eachNode)
    );
    setExpandedNodes(expandingNodes);
    if (expandingNodes[0]) {
      setIsBaseLoading(true);
      const nodesdata = findNodesById(expandingNodes[0]);
      try {
        if (nodesdata) {
          if (nodesdata.children && nodesdata.ChildrenFetched) {
            setIsBaseLoading(false);
            return;
          }

          const response = await fetchChildNodes(nodesdata);
          const updatedTreeData = updateTreeData(
            treeData,
            nodesdata.Id,
            response,
            true
          );
          setTreeData(updatedTreeData);
        }
        setIsBaseLoading(false);
      } catch (e) {
        setIsBaseLoading(false);
      }
    }
  };
  const handleContextMenu = (
    event: MouseEvent,
    nodeID: {id: string; type?: string | null}
  ) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
      nodeId: nodeID
    });
  };
  const handleSearch = async () => {
    try {
      setIsLoadingTree(true);
      const data: any = {
        sql_data: initialResponse,
        data: {SearchKeyword: searchData},
        operation: 'TREEDATASEARCH'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      // Perform the deletion on treeData
      // await deleteItemFromBackend(nodeIdToDelete);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const newTreeDataID = await getCmsData('LMS', 'content-management', {
        tk: encryptRequestData
      });

      const transformedData = transformDataToTreeNode(newTreeDataID.data);
      setTreeData(transformedData);
      setExpanded([]);
      setIsLoadingTree(false);
    } catch (e) {
      setIsLoadingTree(false);
    }
  };
  const handleClose = () => {
    setContextMenu({mouseX: null, mouseY: null, nodeId: {id: null}});
  };
  const generateUniqueId = () => {
    const values = uuidv4();
    // Implement a unique ID generation logic here
    return values;
  };
  const deleteItem = async (nodeIddelete: any) => {
    try {
      setDeleteLoading(true);
      const nodeIdToDelete = {Idnum: nodeIddelete};
      // Check if nodeIdToDelete is not null and not 'root'
      if (nodeIdToDelete === null || nodeIdToDelete.Idnum === 'root') {
        console.error('Cannot delete root node or null');
        return;
      }
      const data: any = {
        sql_data: initialResponse,
        data: {Id: nodeIddelete, Access: false},
        operation: 'MODIFY'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      // Perform the deletion on treeData
      // await deleteItemFromBackend(nodeIdToDelete);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const newTreeDataID = await getCmsData('LMS', 'content-management', {
        tk: encryptRequestData
      });
      setTreeData((prevTreeData: any[]) => {
        // Recursive function to filter out the node and its children and update HasDocuments
        const removeNodeAndUpdateHasDocuments = (nodes: any[]): any[] => {
          return nodes
            .filter(node => node.Id !== nodeIddelete) // Exclude the node to be deleted
            .map(node => {
              const updatedChildren = node.children
                ? removeNodeAndUpdateHasDocuments(node.children)
                : [];
              return {
                ...node,
                children: updatedChildren,
                HasDocuments: updatedChildren.length > 0 // Update HasDocuments based on children
              };
            });
        };

        return removeNodeAndUpdateHasDocuments(prevTreeData);
      });
      // const randomid = generateUniqueId();
      // setuploadId(randomid);
      setSelectedData(null);
      setDeleteLoading(false);
      setDirectDeleteDialogOpen(false);
      handleClose();
    } catch (e) {
      setDirectDeleteDialogOpen(false);
      setDeleteLoading(false);
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  // Helper function to remove deleted items from treeData

  const handleSubmits = async (dataupload: any, errors?: any) => {
    if (errors || !dataupload.UploadedFile) {
      return;
    }
    try {
      const data: any = {
        sql_data: initialResponse,
        data: dataupload,
        operation: 'INSERT'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const response = await getCmsData('LMS', 'content-management', {
        tk: encryptRequestData
      });
      // setuploadId(response.data[0].Id);
      return response.data[0].Id;
      // Handle successful response
    } catch (error) {
      console.error('Error adding file:', error);
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      // Handle errors
    }
  };
  const addItem = async (
    UploadedFile: any,
    filename: any,
    filetype: any,
    type: any,
    parentId: any,
    nodefilename: any,
    erroroccur?: any
  ) => {
    // console.log('filetype', filetype);
    // console.log('fileTypeByUrl(filetype)', fileNameByUrl(filetype));

    let iconvalue = 'openfolder';
    if (fileNameByUrl(filetype)) {
      iconvalue = fileNameByUrl(filetype) ?? 'folder'; // Use a default value
    }
    if (filetype) {
      switch (filetype) {
        case 'application/pdf':
          iconvalue = 'pdf';
          break;
        case 'text/plain':
          iconvalue = 'txt';
          break;
        case 'audio/mpeg':
          iconvalue = 'audio';
          break;
        case 'video/mp4':
          iconvalue = 'video';
          break;
        case 'image/jpeg':
        case 'image/png':
          iconvalue = 'image';
          break;
        case 'embeddedcode':
          iconvalue = 'embedded_icon';
          break;
        case 'linkcode':
          iconvalue = 'link_icon';
          break;
        // add more cases as needed
      }
    }
    const newNode = {
      // Function to generate a unique ID
      Name: `${filename}`, // Default name, can be edited later
      NodeType: nodefilename,
      ParentId: parentId,
      Access: true,
      MimeType: `${filetype}`,
      UploadedFile: UploadedFile,
      Icon: iconvalue,
      UpdatedAt: new Date(),
      children: []
    };

    const addNode = (
      nodes: TreeNode[] | null,
      parentId: string,
      newNode: TreeNode
    ): TreeNode[] => {
      if (nodes === null) {
        return [newNode];
      }

      return nodes.map(node => {
        if (node.Id === parentId) {
          if (String(node.Id) in expanded) {
            return {
              ...node,
              hasDocuments: true,
              childrenFetched: false,
              children: [...(node.children || [])]
            };
          }
          return {
            ...node,
            hasDocuments: true,
            childrenFetched: true,
            children: [
              ...(node.children || []),
              {
                Id: newNode.Id,
                Name: newNode.Name,
                ParentId: newNode.parentId,
                NodeType: newNode.NodeType,
                Icon: newNode.Icon,
                Access: true,
                MimeType: newNode.MimeType,
                UploadedFile: newNode.UploadedFile,
                children: []
              }
            ]
          };
        } else if (node.children) {
          return {
            ...node,
            children: addNode(node.children, parentId, newNode)
          };
        }
        return node;
      });
    };
    const errors = erroroccur;
    const newNodeID = await handleSubmits(newNode, errors);
    setNewId(newNodeID);
    const updatedNode = {...newNode, Id: newNodeID};
    setTreeData(currentTreeData => {
      const values = addNode(currentTreeData, parentId, updatedNode);
      return values;
    });
    setFilesToUpload([]);
  };
  const handleDialogOpen = () => {
    setFileDetails({...initialFileDetails, ParentId: contextMenu.nodeId.id});
    openDialog.onTrue();
  };

  const handleDialogClose = () => {
    openDialog.onFalse();
  };
  useEffect(() => {
    if (!isFullScreen) {
      if (docData) {
        const pathToNode = findNodesById(docData.Id);

        if (pathToNode) {
          // Expand all nodes in the path
          setExpandedNodes(pathToNode.map(String)); // Update expanded nodes

          // Focus on the target node and its children
          pathToNode.forEach((nodeId: any) => {
            const targetNodeElement = document.querySelector(
              `[data-nodeid="${nodeId}"]`
            );
            if (targetNodeElement) {
              targetNodeElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          });
        } else {
          console.warn(`Node with ID ${docData.Id} not found.`);
        }
      }
    }
  }, [isFullScreen]);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) {
      return;
    }
    const fileToUpload: FileToUpload[] = []; // Prepare an array to hold file data for uploading
    Array.from(files).forEach((file, index) => {
      if (file.size > 10 * 1024 * 1024) {
        fileToUpload.push({
          fileData: null,
          fileName: null,
          fileType: null,
          fileError: 'File size exceeds 2MB'
        });
        return;
      }
      const reader = new FileReader();
      reader.onload = (loadEvent: ProgressEvent<FileReader>) => {
        if (typeof loadEvent.target?.result === 'string') {
          fileToUpload.push({
            fileData: loadEvent.target.result,
            fileName: file.name,
            fileType: file.type,
            fileError: ''
          });

          // Update state when all files are processed
          if (fileToUpload.length === files.length) {
            // Assuming `setFilesToUpload` is a new state setter you'll add
            setFilesToUpload(fileToUpload);
          }
        } else {
          console.error('FileReader did not return a string.');
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const handleResizeDocViewer = (e: any, data: any) => {
    const newDocViewerWidth = data.size.width;
    setDocViewerWidth(newDocViewerWidth);
  };
  const handleDoubleClick = async (node: any) => {
    if (source.current) {
      source.current.cancel();
    }
    source.current = axios.CancelToken.source();

    setLoading(true);
    const data: any = {
      sql_data: initialResponse
    };
    const encryptRequestData = EncryptUtils.encryptedData(data);
    const Uploadeddata = await getCmsData(
      'LMS',
      'content-management',
      {
        tk: encryptRequestData
      },
      node.Id,
      'fetching'
    );
    const reqPayload = EncryptUtils.encryptedData({
      userId: Uploadeddata.data[0]
    });
    const response = await getLMSFileData(Uploadeddata.data[0], source.current);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers?.get('Content-Type');
    if (!contentType) {
      throw new Error('Content-Type is missing from the response headers');
    }
    // Create a URL for the Blob
    // const contentType = response.headers.get('Content-Type');
    const arrayBuffer = await response.arrayBuffer();

    // Convert ArrayBuffer to Blob
    const blob = new Blob([arrayBuffer], {type: contentType});
    const blobUrl = URL.createObjectURL(blob);

    // link.download = blobUrl.split('/').pop(); // Use the filename from the URL
    // link.click();
    // URL.revokeObjectURL(fileUrl);
    const base64Data = Uploadeddata.data[0].MimeType;
    if (base64Data) {
      setSelectedData(blobUrl);
      setMimeType(base64Data);
    } else {
      setSelectedData(null);
      setMimeType('');
    }
    setLoading(false);
  };
  const getDocumentViewerComponent = (): JSX.Element => (
    <MainDocViewContainer
      item
      md={12}
      // md={props.subModuleUIData.layout.viewer.grid_columns}
      xs={12}
      sx={{minHeight: '74vh'}}>
      <>
        {!docData && <div id="empty-div" />}
        {!docData && treeData?.length !== 0 && (
          <EmptyContent
            title="No file or folder selected"
            description="Select a file or folder to read"
            imgUrl="/assets/icons/empty/ic_email_selected.svg"
            sx={{
              borderRadius: 1.5,
              bgcolor: 'background.default'
            }}
          />
        )}
        {docData && (
          <CustomLMSDocViewer
            docData={docData}
            setDocData={setDocData}
            UIFieldData={initialResponse}
            height={'72vh'}
          />
        )}
      </>
    </MainDocViewContainer>
  );
  const findNodeById = (nodes: TreeNode[], id: string): TreeNode | null => {
    for (const node of nodes) {
      if (node.Id === id) return node;
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };
  const handleRenameClick = (nodeId: string) => {
    handleClose(); // Close the context menu
    setTimeout(() => {
      const node = findNodeById(treeData, nodeId);
      if (node) {
        setRenameState({isRenaming: true, nodeId: nodeId, newName: node.Name});
      } // Delay of 100ms
    }, 10);
  };
  const updateNodeName = (
    nodes: TreeNode[],
    id: string,
    newName: string
  ): TreeNode[] => {
    return nodes.map(node => {
      if (node.Id === id) {
        return {...node, Name: newName};
      }
      if (node.children) {
        return {...node, children: updateNodeName(node.children, id, newName)};
      }
      return node;
    });
  };
  const handleRenameSubmit = async (nodeId: string) => {
    if (
      renameState.newName.trim() &&
      renameState.newName !== findNodeById(treeData, nodeId)?.Name
    ) {
      const updatedTreeData = updateNodeName(
        treeData,
        nodeId,
        renameState.newName
      );
      setTreeData(updatedTreeData);
      const data: any = {
        sql_data: initialResponse,
        data: {Id: nodeId, Name: renameState.newName},
        operation: 'MODIFY'
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getCmsData('LMS', 'content-management', {
        tk: encryptRequestData
      });
    }
    setRenameState({isRenaming: false, nodeId: null, newName: ''});
  };

  const handleCheck = (nodeId: string, isChecked: boolean) => {
    setCheckedItems(prev => {
      const updatedCheckedItems = {...prev};

      // Recursive function to select or deselect children
      const setChildrenState = (children: any[], checked: boolean) => {
        children.forEach(child => {
          updatedCheckedItems[child.Id] = checked;
          if (child.children) {
            setChildrenState(child.children, checked);
          }
        });
      };

      const findNodeAndSetState = (id: string, nodes: any[]) => {
        for (const node of nodes) {
          if (node.Id === id) {
            updatedCheckedItems[node.Id] = isChecked; // Set the clicked node state
            if (node.children) {
              setChildrenState(node.children, isChecked); // Set children state
            }
            break;
          }
          if (node.children) {
            findNodeAndSetState(id, node.children);
          }
        }
      };

      findNodeAndSetState(nodeId, treeData); // Set state for the clicked node and children
      // updateParentState(nodeId, treeData); // Update parent state based on the new child state

      return updatedCheckedItems;
    });
  };

  const handleDeleteSelected = async () => {
    const itemsToDelete = Object.keys(checkedItems).filter(
      id => checkedItems[id]
    );

    // Use Promise.all to await all deleteItem calls
    await Promise.all(
      itemsToDelete.map(async id => {
        await deleteItem(Number(id));
      })
    );

    // Reset state after deletion
    setDeleteDialogOpen(false);
    setDeleteMode(false);
    setCheckedItems({});
    enqueueSnackbar('The Files are Deleted', SnackBarConfig.getSuccess());
  };
  const handledeletedialog = async (nodeId: string) => {
    await deleteItem(contextMenu.nodeId.id);
    enqueueSnackbar(`The File is Deleted`, SnackBarConfig.getSuccess());
  };
  const handleContextMenuDeleteOption = () => {
    setDeleteMode(true);
    if (
      Object.keys(checkedItems).filter(key => checkedItems[key] === true)
        .length != 0
    ) {
      setDeleteDialogOpen(true);
    } else {
      setDeleteMode(false);
    }
  };
  const handleDeleteOption = (id: string | null) => {
    if (id !== null) {
      setDirectDeleteDialogOpen(true);
    } else {
      setDirectDeleteDialogOpen(false);
    }
  };
  const handleMenuDeleteOption = () => {
    setDeleteMode(true);
  };
  const convertType = (filetype: string) => {
    let iconvalue;
    switch (filetype) {
      case 'pdf_icon':
        iconvalue = 'pdf';
        break;
      case 'text/plain':
        iconvalue = 'txt';
        break;
      case 'audio/mpeg':
        iconvalue = 'audio';
        break;
      case 'video/mp4':
        iconvalue = 'video';
        break;
      case 'image_icon':
        iconvalue = 'image';
        break;
      case 'embedded_icon':
        iconvalue = 'embedded_icon';
        break;
      case 'link_icon':
        iconvalue = 'link_icon';
        break;
      case 'folder_icon':
        iconvalue = 'folder';
        break;
      default:
        iconvalue = filetype;
      // add more cases as needed
    }
    return iconvalue;
  };
  const getCheckState = (id: string): boolean => {
    if (id in checkedItems) {
      return checkedItems[id];
    } else {
      // Default value when the ID is not found
      return false;
    }
  };
  // const isIndeterminate = (node: any): boolean => {
  //   if (!node.children || node.children.length === 0) {
  //     return false; // No children, no indeterminate state
  //   }

  //   const someChildrenChecked = node.children.some(
  //     (child: {Id: string | number}) =>
  //       !!checkedItems[child.Id] || isIndeterminate(child)
  //   );

  //   const allChildrenChecked = node.children.every(
  //     (child: {Id: string | number}) =>
  //       !!checkedItems[child.Id] && !isIndeterminate(child)
  //   );

  //   return someChildrenChecked && !allChildrenChecked;
  // };

  const renderTree = (node: any) => {
    const showExpandIcon =
      node.HasDocuments || (node.children && node.children.length > 0);

    return (
      <TreeItem
        key={node.Id}
        nodeId={String(node.Id)}
        label={
          renameState.isRenaming && renameState.nodeId === node.Id ? (
            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <FileThumbnail
                tooltip={true}
                file={convertType(node.Icon) || ''}
                sx={{width: 15, height: 15}}
              />
              <input
                autoFocus
                type="text"
                value={renameState.newName}
                onChange={e =>
                  setRenameState({...renameState, newName: e.target.value})
                }
                onBlur={() => {
                  // handleRenameSubmit(node.Id);
                  setRenameState({
                    isRenaming: false,
                    nodeId: null,
                    newName: ''
                  });
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    handleRenameSubmit(node.Id);
                  }
                }}
              />
            </div>
          ) : deleteMode ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                lineHeight: '0.5rem',
                gap: '5px'
              }}>
              {deleteMode && (
                <Checkbox
                  style={{padding: '1px'}}
                  checked={getCheckState(node.Id)}
                  // indeterminate={isIndeterminate(node)}
                  onChange={event => handleCheck(node.Id, event.target.checked)}
                  size="small"
                  sx={{
                    '& .MuiSvgIcon-root': {
                      // Continue to customize the icon size as needed
                      fontSize: '1.3rem',
                      display: 'inline-block',

                      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                    }
                  }}
                />
              )}
              <FileThumbnail
                tooltip={true}
                file={convertType(node.Icon) || ''}
                sx={{width: 15, height: 15}}
              />
              <span style={{fontSize: '14px', whiteSpace: 'nowrap'}}>
                {node.Name}
              </span>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                lineHeight: '0.5rem',
                gap: '5px',
                paddingRight: '5px'
              }}
              onClick={e => {
                // e.stopPropagation();
                if (node.NodeType !== 'Folder') {
                  // handleDoubleClick(node);
                  setDocData(node);
                }
              }}>
              <FileThumbnail
                tooltip={true}
                file={convertType(node.Icon) || ''}
                sx={{width: 15, height: 15}}
              />
              <span
                style={{
                  fontSize: '14px',
                  whiteSpace: 'nowrap',
                  paddingRight: '8px'
                }}>
                {node.Name}
              </span>
            </div>
          )
        }
        onContextMenu={e => {
          e.preventDefault(); // Prevent default action
          e.stopPropagation(); // Stop event from bubbling up
          handleContextMenu(e, {id: node.Id, type: node.Icon});
        }}
        sx={{
          padding: '4px 8px'
        }}>
        {showExpandIcon ? (
          node.children?.length ? (
            node.children.map((childNode: any) => renderTree(childNode))
          ) : isBaseLoading ? (
            <ComponentLoader />
          ) : (
            <div style={{padding: '10px', color: '#888'}}>available</div>
          )
        ) : null}
      </TreeItem>
    );
  };

  const handleExpand = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F2' && contextMenu.nodeId.id) {
        setRenameState({
          isRenaming: true,
          nodeId: contextMenu.nodeId.id,
          newName: findNodeById(treeData, contextMenu.nodeId.id)?.Name || ''
        });
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [contextMenu?.nodeId.id, treeData]);

  return (
    <Box sx={{height: '80vh', display: 'flex', flexDirection: 'column'}}>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh'
          }}>
          <ComponentLoader loaderSize={10} />
        </Box>
      ) : (
        <Grid container sx={{flex: 1}}>
          {!isFullScreen && (
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                background: '#e0f7fa',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2,
                borderRight: '1px solid #ccc',
                position: 'relative',
                maxHeight: '80vh',
                overflow: 'auto'
              }}>
              <TextField
                label="Search"
                name="Search"
                placeholder="Search Files Only"
                size="small"
                sx={{
                  '.MuiOutlinedInput-root': {
                    paddingRight: '0px'
                  }
                }}
                value={searchData}
                onChange={e => {
                  setSearchData(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleSearch}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              {searchData && (
                <Button
                  variant="contained"
                  color="inherit"
                  size="small"
                  sx={{marginTop: '4px'}}
                  onClick={() => {
                    setSearchData('');
                    const randomid = generateUniqueId();
                    setuploadId(randomid);
                    setExpanded([]);
                  }}>
                  Clear
                </Button>
              )}
              {deleteMode ? (
                <Box padding={1}>
                  <LoadingButton
                    variant="contained"
                    color="warning"
                    size="small"
                    sx={{marginRight: '4px'}}
                    onClick={handleContextMenuDeleteOption}>
                    Delete
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setDeleteMode(false);
                      setCheckedItems({});
                    }}>
                    Cancel
                  </Button>
                </Box>
              ) : (
                <Box padding={1}>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={handleMenuDeleteOption}>
                    Delete Multiple
                  </Button>
                </Box>
              )}
              <div>
                {isLoadingTree ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                    <ComponentLoader loaderSize={10} />
                  </Box>
                ) : (
                  <TreeView
                    defaultCollapseIcon={
                      <ArrowDropDownIcon
                        style={{color: theme.palette.text.disabled}}
                      />
                    }
                    defaultEndIcon={''}
                    defaultExpandIcon={
                      <ArrowRightIcon
                        style={{color: theme.palette.text.disabled}}
                      />
                    }
                    expanded={expanded}
                    onNodeToggle={handleFolderChange}
                    sx={{width: 'fit-content'}}>
                    {treeData.map(renderTree)}
                  </TreeView>
                )}
              </div>
            </Grid>
          )}
          <Grid>
            <Box>
              <Button
                variant="contained"
                onClick={handleExpand}
                sx={{
                  minWidth: '20px',
                  minHeight: '20px',
                  borderRadius: '50%',
                  position: 'absolute',
                  transform: 'translateX(-10px)',
                  zIndex: 10,
                  padding: 0,
                  background: '#ffffff',
                  color: '#637381',
                  boxShadow: '0px 0px 5px rgba(0,0,0,0)'
                }}>
                {isFullScreen ? '>' : '<'}
              </Button>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={isFullScreen ? 12 : 9}
            sx={{
              background: '#fff3e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 2
            }}>
            {getDocumentViewerComponent()}
          </Grid>
          <Menu
            open={contextMenu.mouseY !== null}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={
              contextMenu.mouseY !== null && contextMenu.mouseX !== null
                ? {top: contextMenu.mouseY, left: contextMenu.mouseX}
                : undefined
            }>
            <MenuItem
              onClick={() => {
                handleDeleteOption(contextMenu.nodeId.id);
              }}>
              Delete
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (contextMenu?.nodeId?.id) {
                  handleRenameClick(contextMenu?.nodeId.id);
                }
              }}>
              Rename
            </MenuItem>
            {(contextMenu?.nodeId?.type === 'folder' ||
              contextMenu?.nodeId?.type === 'folder_icon') && (
              <>
                <MenuItem
                  onClick={() => {
                    if (contextMenu.nodeId) {
                      setIsAddFolderOpen(true);
                    }
                  }}>
                  Add New Folder
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (contextMenu.nodeId !== null) {
                      handleDialogOpen();
                    }
                  }}>
                  Add New File
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (contextMenu.nodeId) {
                      setIsAddLinkOpen(true);
                    }
                  }}>
                  Add New Link
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (contextMenu.nodeId) {
                      setIsAddEmbeddedOpen(true);
                    }
                  }}>
                  Add New Embedded Code
                </MenuItem>
              </>
            )}

            {isAddFolderOpen && contextMenu?.nodeId?.id && (
              <AddFolder
                token={initialResponse}
                parentId={contextMenu?.nodeId?.id}
                open={isAddFolderOpen}
                onCancel={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddFolderOpen(false);
                  handleClose();
                }}
                setTreeData={setTreeData}
                data={treeData}
                onClose={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddFolderOpen(false);
                  handleClose();
                }}
              />
            )}
            {isAddLinkOpen && contextMenu?.nodeId?.id && (
              <AddLinkCodeDialog
                token={initialResponse}
                parentId={contextMenu.nodeId.id}
                open={isAddLinkOpen}
                onCancel={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddLinkOpen(false);
                  handleClose();
                }}
                setTreeData={setTreeData}
                data={treeData}
                onClose={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddLinkOpen(false);
                  handleClose();
                }}
              />
            )}
            {isAddEmbeddedOpen && contextMenu.nodeId.id && (
              <AddEmbeddedCodeDialog
                token={initialResponse}
                parentId={contextMenu.nodeId.id}
                open={isAddEmbeddedOpen}
                onCancel={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddEmbeddedOpen(false);
                  handleClose();
                }}
                setTreeData={setTreeData}
                data={treeData}
                onClose={() => {
                  // setuploadId(generateUniqueId());
                  setIsAddEmbeddedOpen(false);
                  handleClose();
                }}
              />
            )}
          </Menu>

          <CMSUpload
            open={openDialog.value}
            onClose={openDialog.onFalse}
            title="New Folder"
            onDataUpload={(e: CustomFile[]) => {
              e.map(data => {
                addItem(
                  data.preview,
                  data.name,
                  data.type,
                  fileDetails,
                  contextMenu.nodeId.id,
                  'File'
                );
                handleDialogClose();
                handleClose();
                enqueueSnackbar(
                  'The Files are Added',
                  SnackBarConfig.getSuccess()
                );
              });
            }}
          />
          {deleteDialogOpen && (
            <Dialog
              fullWidth
              maxWidth="xs"
              open={deleteDialogOpen}
              onClose={() => setDeleteDialogOpen(false)}>
              <DialogTitle sx={{pb: 2}}>Delete Files</DialogTitle>

              <DialogContent sx={{typography: 'body2'}}>
                {`Are you sure you want to delete ${
                  Object.values(checkedItems).filter(v => v).length
                } item(s)?`}
              </DialogContent>

              <DialogActions>
                <LoadingButton
                  variant="contained"
                  color="error"
                  loading={deleteLoading}
                  onClick={handleDeleteSelected}>
                  Delete
                </LoadingButton>

                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={() => {
                    setDeleteMode(false);
                    setDeleteDialogOpen(false);
                    setCheckedItems({});
                  }}>
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {directdeleteDialogOpen && (
            <Dialog
              fullWidth
              maxWidth="xs"
              open={directdeleteDialogOpen}
              onClose={() => setDirectDeleteDialogOpen(false)}>
              <DialogTitle sx={{pb: 2}}>Delete File</DialogTitle>

              <DialogContent sx={{typography: 'body2'}}>
                {`Are you sure you want to delete the item?`}
              </DialogContent>

              <DialogActions>
                <LoadingButton
                  variant="contained"
                  color="error"
                  loading={deleteLoading}
                  onClick={() =>
                    handledeletedialog(contextMenu.nodeId.id as string)
                  }>
                  Delete
                </LoadingButton>

                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={() => {
                    // setDirectDeleteDialogOpen(false);
                    handleClose();
                  }}>
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      )}
    </Box>
  );
};

export default CmsComponent;
